import { Box, Checkbox, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import { useStyles } from "../../../shared/styles/useStyles";
import { Dispatch } from "react";

interface FormHeaderProps {
  setIsAnonymous: Dispatch<React.SetStateAction<boolean>>;
}

function FormHeader({ setIsAnonymous }: FormHeaderProps) {
  const classes = useStyles();

  return (
    <>
      <Typography
        variant="body2"
        className={clsx(
          classes.paragraphText,
          classes.fontSize18,
          classes.fontWeightExtraBold
        )}
      >
        <FormattedMessage id="PQRSDF" />:
      </Typography>
      <Box marginTop={"8px"}>
        <Checkbox
          className="pqrs-checkbox"
          name="anonymous"
          onChange={(e) => {
            setIsAnonymous(e.target.checked);
          }}
          color="default"
          inputProps={{ "aria-label": "primary checkbox" }}
        />
        <label
          className="form-text"
          style={{ marginTop: "10px", marginLeft: "-5px" }}
        >
          <FormattedMessage id="AnonymouslyForm" />
        </label>
      </Box>
      <Box marginTop={"6px"}>
        <Typography
          variant="body2"
          className={clsx(classes.paragraphText, classes.fontWeightExtraBold)}
        >
          <FormattedMessage id="FillDetailsRequest" />:
        </Typography>
      </Box>
      <Typography
        variant="body2"
        className={clsx(classes.mb1, classes.paragraphText)}
      >
        <FormattedMessage id="RememberMarkedRequired" />
      </Typography>
    </>
  );
}

export default FormHeader;
